import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { generateUrl } from "Services/withDefaultParams";
import withDefaultParams from "Services/withDefaultParams";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import Routes from "Configs/routes";
import { AdverBlockContainer } from "Containers/AdBlocksContainer";
import RecentlyConnectedTariffsContainer from "Containers/RecentlyConnectedTariffsContainer";
import { TariffsContainer } from "Containers/Tariffs";
import { ReviewBranch } from "ComponentsUI/Reviews";
import OneClick from "Containers/OneClick";
import { PaddingBottom } from "ComponentsUI/Spacings";
import { Col } from "ComponentsUI/Styles/Grid";
import { EmptyStub } from "ComponentsUI/EmptyStub";
import Button from "ComponentsUI/Button";
import BrandButton from "Containers/Buttons/BrandButton";
import { NoContainer } from "ComponentsUI/Spacings";

@withRouter
@withDefaultParams
@inject("ApplicationModel")
@observer
export default class ReviewList extends React.Component {
	static defaultProps = {
		data: [],
	};

	goToFeedbackPage() {
		let urlToFeedback = generateUrl(Routes.AddReview.route, {
			regionUrl: this.props.match.params.regionUrl,
		});
		this.props.history.push(urlToFeedback);
	}

	generateBranches(data) {
		let titleText = this.props.titleText;
		let text = this.props.ApplicationModel.text;
		let textHeaders;
		if (titleText) {
			textHeaders =
				text.menuExclusives + " " + titleText.provider + " в " + titleText.region.prepositional;
		}
		if (this.props.stub) {
			return data.map((item, index) => {
				return (
					<ReviewBranch
						succesfullyReplyCallback={this.props.succesfullyReplyCallback}
						key={index}
						stub={this.props.stub}
						data={item}
						text={text}
						button={false}
						withReply={false}
						markReviewAsViewed={() => {}}
					/>
				);
			});
		}
		let blocks = [];
		data.forEach((item) => {
			let urlToFullReview = !!item.provider.url_name
				? generateUrl(Routes.ReviewItem.route, {
						regionUrl: this.props.match.params.regionUrl,
						providerName: item.provider.url_name,
						reviewId: item.id,
					})
				: "/";
			let urlToProvider = !!item.provider.url_name
				? generateUrl(Routes.ProviderRates.route, {
						regionUrl: this.props.match.params.regionUrl,
						providerName: item.provider.url_name,
					})
				: "/";
			blocks.push(
				<ReviewBranch
					key={item.id}
					succesfullyReplyCallback={this.props.succesfullyReplyCallback}
					data={item}
					text={text}
					urlToFullReview={urlToFullReview}
					urlToProvider={urlToProvider}
					singleReview={this.props.singleReview}
					button={item.answers.count > 1}
					withReply={this.props.withReply}
					markReviewAsViewed={(id) =>
						this.props.ApplicationModel.sendingStore.markReviewAsViewed(id)
					}
				/>
			);
		});
		// тут добавляем блок с 3я тарифами провайдера
		let tariffsBlock = this.props.tariffsForReviewsProvider ? (
			<NoContainer key={"tariffs_action"}>
				<TariffsContainer
					tariffs={this.props.tariffsForReviewsProvider}
					showHeaderV2={true}
					textHeaders={textHeaders}
					isReviewsProviders={true}
				/>
				{this.props.provider_settings.brand_button && (
					<div style={{ display: "flex", "justify-content": "center" }}>
						<BrandButton
							brand_button={this.props.provider_settings.brand_button}
							typeBrandButton={"Footer"}
							click={"prov2"}
							providerid={this.props.providerId}
						/>
					</div>
				)}
			</NoContainer>
		) : null;

		// тут дабавляется блок из 2х
		let adblock = (
			<NoContainer key="adblock">
				<AdverBlockContainer
					lead_form_type={this.props.lead_form_type}
					providerId={this.props.providerId}
					fromReviews={true}
				/>
			</NoContainer>
		);

		let recentlyBlock = (
			<NoContainer key={"recently_tariffs_in_reviews_provider"}>
				<RecentlyConnectedTariffsContainer
					{...this.props}
					isReviewsProviders={true}
					pageName={this.props.pageName}
					styleReviewsProvider={true}
				/>
			</NoContainer>
		);

		if (this.props.providerReviews) {
			if (this.props.vipProvider && !!this.props.tariffsForReviewsProvider.length) {
				if (blocks.length > 3) {
					blocks.splice(3, 0, tariffsBlock);
				} else {
					blocks.push(tariffsBlock);
				}
			} else if (!this.props.vipProvider) {
				if (blocks.length > 3) {
					blocks.splice(3, 0, recentlyBlock);
				} else {
					blocks.push(recentlyBlock);
				}
			}

			if (!this.props.withReply && !this.props.withoutAdblock) {
				if (
					blocks.length > 6 &&
					((this.props.vipProvider && !!this.props.tariffsForReviewsProvider.length) ||
						!this.props.vipProvider)
				) {
					blocks.splice(6, 0, adblock);
				} else if (blocks.length > 4) {
					blocks.splice(4, 0, adblock);
				} else {
					blocks.push(adblock);
				}
			}
		} else {
			if (!this.props.withReply && !this.props.withoutAdblock) {
				if (blocks.length > 4) {
					blocks.splice(4, 0, adblock);
				} else {
					blocks.push(adblock);
				}
			}
		}

		return blocks;
	}

	render() {
		let text = this.props.ApplicationModel.text;
		if (!this.props.data.length) {
			return (
				<Container>
					<Row>
						<Col
							lg={{ size: 4, offset: 4 }}
							md={{ size: 4, offset: 4 }}
							sm={{ size: 4, offset: 4 }}
							xs={{ size: 6, offset: 3 }}
						>
							<EmptyStub
								header={text.REVIEWS_EMPTY_STUB_HEADER}
								text={text.REVIEWS_EMPTY_STUB_TEXT}
								icon={
									<span
										className="icon48 icon-balance"
										style={{
											fontSize: "48px",
											color: "#5812fe",
										}}
									/>
								}
								button={
									<Button
										typeText={"small"}
										size={"low"}
										status={"withoutAccent"}
										onClick={() => this.goToFeedbackPage()}
									>
										<span
											className="icon48 icon-chat-1"
											style={{
												fontSize: "24px",
												color: "#d3cee1",
											}}
										/>
										{text.WRITE_REVIEW}
									</Button>
								}
							/>
						</Col>
					</Row>
				</Container>
			);
		}
		let oneReview = this.props.data.length == 1 ? true : false;
		return (
			<Container>
				<Row>
					<Col xs="12">{this.generateBranches(this.props.data)}</Col>
				</Row>
				{oneReview && <OneClick />}
			</Container>
		);
	}
}
